<template>
    <div class="unsubscribe-page">
        <div class="unsubscribe-card">

            <h1 class="unsubscribe-title">Email Preferences</h1>

            <p v-if="loading" class="unsubscribe-text">
                Processing your request...
            </p>

            <template v-else>

                <!-- SUCCESS -->
                <template v-if="status === 'ok'">
                    <p class="unsubscribe-text">
                        You've been successfully unsubscribed and we won't send any further emails to this address.
                    </p>

                    <p v-if="workplaceName" class="unsubscribe-subtext">
                        {{ workplaceName }}
                    </p>
                </template>

                <!-- ALREADY UNSUBSCRIBED -->
                <template v-else-if="status === 'already_unsubscribed'">
                    <p class="unsubscribe-text">
                        This email address was already unsubscribed.
                    </p>

                    <p class="unsubscribe-subtext">
                        No further action is needed.
                    </p>

                    <p v-if="workplaceName" class="unsubscribe-subtext">
                        {{ workplaceName }}
                    </p>
                </template>

                <!-- ERROR -->
                <template v-else>
                    <p class="unsubscribe-text">
                        Sorry — we couldn't process your unsubscribe request.
                    </p>

                    <p class="unsubscribe-subtext">
                        Please contact
                        <a href="mailto:hello@thanku.app">hello@thanku.app</a>
                        and we'll take care of it.
                    </p>
                </template>

            </template>

        </div>
    </div>
</template>

<script>
const Parse = require("parse/node");

export default {

    name: "UnsubscribeEasyTip",

    inject: ["appId", "appJSKey"],

    data() {
        return {
            loading: true,
            status: "",
            workplaceName: ""
        };
    },

    async mounted() {

        try {

            // ✅ Ensure Parse is initialized (important for direct email link opens)
            if (!Parse.applicationId) {
                Parse.serverURL = "https://parseapi.back4app.com/";
                Parse.initialize(this.appId, this.appJSKey);
            }

            const wid = this.$route.query.wid;
            const templateName = this.$route.query.templateName;

            if (!wid) {
                this.status = "error";
                this.loading = false;
                return;
            }

            const result = await Parse.Cloud.run("actionUnsubscribeEasyTipCampaign", {
                wid: wid,
                templateName: templateName
            });

            this.status = result.status || "error";
            this.workplaceName = result.workplaceName || "";

            console.log("UNSUB RESULT:", result);

        } catch (e) {

            this.status = "error";

        } finally {

            this.loading = false;

        }
    }

};
</script>

<style scoped>

.unsubscribe-page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background: #ffffff;
    box-sizing: border-box;
}

.unsubscribe-card {
    width: 100%;
    max-width: 560px;
    border: 1px solid #e5e5e5;
    border-radius: 10px;
    padding: 32px 28px;
    box-sizing: border-box;
    background: #ffffff;
}

.unsubscribe-title {
    margin: 0 0 18px 0;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 28px;
    font-weight: 600;
    color: #444444;
}

.unsubscribe-text {
    margin: 0;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 16px;
    line-height: 26px;
    color: #555555;
}

.unsubscribe-subtext {
    margin-top: 18px;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 14px;
    line-height: 22px;
    color: #888888;
}

a {
    color: #1188E6;
    text-decoration: none;
}

a:hover {
    text-decoration: underline;
}

</style>